import React from 'react'
import Image from 'react-bootstrap/Image'

export default function HelpGames() {
    return (
        <div>
            <div className='c_c'>
                <Image className='Tr_block_img' src='https://img.freepik.com/free-vector/living-room-interior-at-night-with-gamer-stuff_107791-15896.jpg?w=1380&t=st=1672777474~exp=1672778074~hmac=5330b835c09047bac041faaa795176c978b817cfe99b20579fa8ac47d866c3fa'>
                </Image>
            </div>
            <div className='All_block_one'>
                <p className='All_text_block_one'>Браузерные игры, steam игры и просто общение, одобренные сервером WorldGames!</p>
            </div>
            <div className='Tr_stick'></div>
        </div>
    )
}
